export const MAX_RECORDS_DISPLAY = 10;
export const MAX_RECORDS_FETCH = 100; // Fetch more records to ensure we have enough after filtering
export const FILTER_STORAGE_KEY = 'axiom-pair-list-hide-pairs-without-related';
export const HIGHLIGHT_DURATION_MS = 500;
